import { cn } from '../lib/utils';

interface Props {
  streak: number;
  className?: string;
}

export function StreakIndicator({ streak, className }: Props) {
  if (streak === 0) {
    return (
      <span className={cn('font-display-alt text-xs uppercase tracking-widest text-text-faint', className)}>
        No streak
      </span>
    );
  }
  const hot = streak >= 7;
  const warm = streak >= 3;
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 font-chunky text-sm',
        hot ? 'text-trophy-gold animate-pulse' : warm ? 'text-trophy-gold' : 'text-pitch',
        className,
      )}
    >
      <span aria-hidden>🔥</span>
      <span className="font-mono">{streak}</span>
      <span className="font-display-alt text-[10px] uppercase tracking-widest text-text-dim">
        day{streak === 1 ? '' : 's'}
      </span>
    </span>
  );
}
